<div class="dashboard">
    <app-counts></app-counts>
    <app-customerlist></app-customerlist>
</div>
